import { toast } from 'react-toastify'
import { hashMessage } from 'utils/standard/strings'

const wrapWithIdentifier =
  (method) =>
  (message, options = {}) =>
    method(message, { toastId: hashMessage(message), ...options })

export const toaster = {
  success: wrapWithIdentifier(toast.success),
  error: wrapWithIdentifier(toast.error),
  warn: wrapWithIdentifier(toast.warn),
  info: wrapWithIdentifier(toast.info),
  dismiss: toast.dismiss,
  isActive: toast.isActive,
  update: toast.update,
}
